import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "./Navbarmenu.css";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchAdminUser } from "./Redux/AdminUserSlice";
import { useTabContext } from "../TabContext";
// import '/node_modules/bootstrap/dist/css/bootstrap.min.css'

const Navbarmenu = () => {
  const {setActivePage} = useTabContext()
 const dispatch = useDispatch();
useEffect(()=>{
  dispatch(fetchAdminUser())
},[])
 const [isMenu, setisMenu] = useState(false);
 const [isResponsiveclose, setResponsiveclose] = useState(false);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 let loggedInEnterpriseId = "";
 const isAdminUser = useSelector((state)=>state?.adminUser?.adminUsers)
//  console.log("isAdminUser", isAdminUser)
 if (activeAccount) loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 const SMEUsers = [
  "reshmi.haridas.m",
  "arpita.m.singh",
  "h.srinivasan",
  "d.kumari.vaishnava",
  "varsha.a.tyagi",
  "jeevadharani.ramanan",
  "narendra.reddy.mutra",
  "keerthi.bhupelli",
  "aluru.akash",
  "poruri.rama.pavani",
  "ankur.e.mishra",
  "uma.rani.battu",
  "manasa.velagaleti"
 ];
 const THAdmin = isAdminUser && isAdminUser?.filter((role) => role.assigned_role.includes("TH"))
//  const THUsers = THAdmin.map((user)=>user)
 const THUsers = THAdmin.map((user) =>user.EnterpriseID)

//  const THUsers = [
//   "keerthi.bhupelli",
//   "reshmi.haridas.m",
//   "arpita.m.singh",
//   "h.srinivasan",
//   "d.kumari.vaishnava",
//   "varsha.a.tyagi",
//   "jeevadharani.ramanan",
//   "narendra.reddy.mutra",
//   "manasa.velagaleti",
//   "aluru.akash",
//   "ankur.e.mishra",
//   "uma.rani.battu",
//   "poruri.rama.pavani"
//  ];
 //  useEffect(() => {
 //   loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 //   dispatch(checkUserPresent(loggedInEnterpriseId));
 //  }, [activeAccount]);
 let isSMEPresent = useSelector((state) => state.sme.isSMEUSerPresent);
 console.log('sme check', useSelector((state) => state))

 const toggleClass = () => {
  setisMenu(isMenu === false ? true : false);
  setResponsiveclose(isResponsiveclose === false ? true : false);
 };
 let boxClass = ["main-menu"];
 if (isMenu) {
  boxClass.push("menuq2");
 } else {
  boxClass.push("");
 }

 return (
  <header className="header__middle">
   <div className="head-container">
    <div className="row-fluid">
     <div className="header__middle__menus">
      <nav className="main-nav ">
       {/* Responsive Menu Button */}
       {isResponsiveclose === true ? (
        <>
         <span
          className="menubar__button"
          style={{ display: "none" }}
          onClick={toggleClass}
         >
          <FiXCircle />
         </span>
        </>
       ) : (
        <>
         <span
          className="menubar__button"
          style={{ display: "none" }}
          onClick={toggleClass}
         >
          <FiAlignRight />
         </span>
        </>
       )}
       <ul className={boxClass.join(" ")}>
        <li className="menu-item">
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          exact
          to={"/"}
         >
          Home
         </NavLink>
        </li>
        {/* <li className="menu-item">
         <NavLink
          to="/faq"
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          exact
         >
          FAQs
         </NavLink>
        </li> */}
        {SMEUsers.includes(loggedInEnterpriseId) ? (
         <li className="menu-item">
          <NavLink
           to="/SME"
           activeClassName="is-active"
           className="nav-links"
           onClick={() => {toggleClass(); setActivePage(false)}}
           exact
          >
           SME
          </NavLink>
         </li>
        ) : isSMEPresent ? (
         <li className="menu-item">
          <NavLink
           to="/SME"
           activeClassName="is-active"
           className="nav-links"
           onClick={() => {toggleClass(); setActivePage(false)}}
           exact
          >
           SME
          </NavLink>
         </li>
        ) : null}
        {THUsers.includes(loggedInEnterpriseId) ? (
         <li className="menu-item">
          <NavLink
           to="/TH"
           activeClassName="is-active"
           className="nav-links"
           onClick={() => {toggleClass(); setActivePage(false)}}
           exact
          >
           TH
          </NavLink>
         </li>
        ) : null}
       </ul>
      </nav>
     </div>
    </div>
   </div>
  </header>
 );
};

export default Navbarmenu;
